import React from 'react';
import { Grid } from '@devexpress/dx-react-grid-material-ui';

import { expandToFillParentStyles } from '@paragon/client-tools';

export function GridRoot(props: Grid.RootProps) {
  return <Grid.Root {...props} sx={{ ...expandToFillParentStyles.targetStyleProps }} />;
}
